import {
  HomeOutlined,
  ClockCircleOutlined,
  LogoutOutlined,
  ThunderboltOutlined,
  MenuUnfoldOutlined
} from '@ant-design/icons'
import { IMenuEntry } from 'components/Header/config'

export const PRIVATE_MENU_CONFIGS: IMenuEntry[] = [
  {
    label: 'Home',
    icon: HomeOutlined,
    href: '/send',
    actives: ['/send'],
  },
  {
    label: 'History',
    icon: ClockCircleOutlined,
    href: '/transactions',
    actives: ['/transactions'],
  },
  {
    label: 'Send',
    icon: LogoutOutlined,
    href: '/send-confirm',
    actives: ['/send-confirm'],
  },
  {
    label: 'ALO',
    icon: ThunderboltOutlined,
    href: '#',
    actives: ['/#ALO'],
  },
  {
    label: 'Merchant',
    icon: MenuUnfoldOutlined,
    href: '/merchant',
    actives: ['/merchant'],
  },
]
